import { Tabs } from '@ygtechnologies/rubus-ui';
import React from 'react';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import MacGyverUsersTable from '@/components/MacGyverUsers/MacGyverUsersTable';
import FollowerMaintenance from './FollowerMaintenance';

export type SettingsTab = 'users' | 'maintenance';

interface TabSettings {
    id: SettingsTab;
    name: string;
    component: React.ComponentType;
}

const tabs: TabSettings[] = [
    {
        id: 'users',
        name: 'Users',
        component: MacGyverUsersTable,
    },
    {
        id: 'maintenance',
        name: 'Maintenance',
        component: FollowerMaintenance,
    },
];

const SettingsPage: React.FC<{}> = () => {
    const { tab } = useParams<{ tab?: SettingsTab }>();
    const activeTab = tab || 'users';
    const activeTabConfig = tabs.find((x) => x.id === activeTab);
    const ActiveComponent = activeTabConfig?.component;

    return (
        <div>
            <h2>Settings</h2>
            <Tabs.Container activeId={activeTab} variant="underline">
                {tabs.map((tabConfig) => (
                    <Tabs.Tab
                        key={tabConfig.id}
                        id={tabConfig.id}
                        as={Link}
                        to={`/settings/${tabConfig.id}`}
                        label={tabConfig.name}
                    />
                ))}
                <Tabs.Content>
                    <div className="tab-panel">{ActiveComponent && <ActiveComponent />}</div>
                </Tabs.Content>
            </Tabs.Container>
        </div>
    );
};

export default SettingsPage;
